import { Skeleton as MUISkeleton } from '@mui/material';
import { SkeletonProps as MUISkeletonProps } from '@mui/material/Skeleton';

type SkeletonProps = MUISkeletonProps & {
  show?: boolean;
};
export function Skeleton({ show = true, children, ...props }: SkeletonProps) {
  return <>{show ? <MUISkeleton {...props}>{children}</MUISkeleton> : children}</>;
}
